export default __webpack_public_path__ + "static/media/11.8cbf30ba.jpg";